<script setup lang="ts">
const colorMode = useColorMode();
const isLight = computed(() => colorMode.value !== 'dark');

defineProps<{
  light: string;
  dark: string;
}>();
</script>

<template>
  <svg v-if="isLight" class="flex-shrink-0 text-[#501D71]">
    <use :href="light" />
  </svg>
  <svg v-else class="flex-shrink-0">
    <use :href="dark" />
  </svg>
</template>
